import { _ as _extends } from '../_rollupPluginBabelHelpers-e8fb2e5c.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { c as classnames } from '../index-6ff23041.js';
import { k as keyValueConfig } from '../configs-fed6ac34.js';
import Icon from '../Icon/index.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "[data-gene-ui-version=\"2.13.0\"] .geneKeyValue{align-items:flex-start;display:flex;flex-wrap:wrap;width:100%}[data-gene-ui-version=\"2.13.0\"] .geneKeyValue--horizontal{align-items:center;flex-wrap:nowrap}[data-gene-ui-version=\"2.13.0\"] .geneKeyValue__icon{padding:0 0 0 8px}[data-gene-ui-version=\"2.13.0\"] .geneKeyValue__label{color:#3c4043b3;flex:1 1;font-size:12px;font-weight:600;line-height:24px;margin:0 0 1rem 1rem;max-width:100%;width:100%}[data-gene-ui-version=\"2.13.0\"] .geneKeyValue__label--horizontal{flex:none;margin:0 0 0 1rem;max-width:50%;width:auto}[data-gene-ui-version=\"2.13.0\"] .geneKeyValue__value{font-size:14px;font-weight:600;line-height:24px;margin:0 1rem;max-width:100%;width:100%}[data-gene-ui-version=\"2.13.0\"] .geneKeyValue__value--horizontal{margin:0 1rem;max-width:50%}[data-gene-ui-version=\"2.13.0\"] .geneKeyValue__iconWrapper+p+p:not(.geneKeyValue__value--horizontal){margin:0 3.2rem 0 4.2rem}[data-gene-ui-version=\"2.13.0\"] [dir=rtl] .geneKeyValue__iconWrapper+p+p:not(.geneKeyValue__value--horizontal){margin:0 3.2rem 0 0}[data-gene-ui-version=\"2.13.0\"] [dir=rtl] .geneKeyValue__label{direction:ltr;margin:0 1rem 1rem 0}[data-gene-ui-version=\"2.13.0\"] [dir=rtl] .geneKeyValue__label--horizontal{margin:0 0 0 1rem}[data-gene-ui-version=\"2.13.0\"] [dir=rtl] .geneKeyValue__value{direction:ltr}[data-gene-ui-version=\"2.13.0\"] [dir=rtl] .geneKeyValue__iconWrapper+p:not(.geneKeyValue__label--horizontal){margin:0 0 1rem}";
styleInject(css_248z);

// TODO need to refine where is using restProps
function KeyValue(_ref) {
  var _keyValueConfig$appea, _keyValueConfig$appea2, _keyValueConfig$appea3, _keyValueConfig$appea4;
  let {
    label,
    value,
    className,
    icon,
    appearance,
    ...restProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, restProps, {
    className: classnames("geneKeyValue ".concat(className), (_keyValueConfig$appea = keyValueConfig.appearance[appearance]) === null || _keyValueConfig$appea === void 0 ? void 0 : _keyValueConfig$appea.parentItemClassName)
  }), icon && /*#__PURE__*/React__default.createElement("div", {
    className: "geneKeyValue__iconWrapper"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: icon,
    className: classnames('geneKeyValue__icon', (_keyValueConfig$appea2 = keyValueConfig.appearance[appearance]) === null || _keyValueConfig$appea2 === void 0 ? void 0 : _keyValueConfig$appea2.iconClassName)
  })), /*#__PURE__*/React__default.createElement("p", {
    role: "heading",
    "aria-level": "1",
    className: classnames('geneKeyValue__label ellipsis-text', (_keyValueConfig$appea3 = keyValueConfig.appearance[appearance]) === null || _keyValueConfig$appea3 === void 0 ? void 0 : _keyValueConfig$appea3.labelClassName)
  }, label), /*#__PURE__*/React__default.createElement("p", {
    className: classnames('geneKeyValue__value ellipsis-text', (_keyValueConfig$appea4 = keyValueConfig.appearance[appearance]) === null || _keyValueConfig$appea4 === void 0 ? void 0 : _keyValueConfig$appea4.valueClassName)
  }, value));
}
KeyValue.propTypes = {
  /**
   * Label for 'KeyValue'.
   */
  label: PropTypes.node.isRequired,
  /**
   * Value for 'KeyValue'.
   */
  value: PropTypes.node,
  /**
   * External/Additional className that can be added to 'KeyValue' component.
   */
  className: PropTypes.string,
  /**
   * The way how the KeyValue should be displayed.
   */
  appearance: PropTypes.oneOf(Object.keys(keyValueConfig.appearance))
};
KeyValue.defaultProps = {
  value: '',
  className: '',
  appearance: keyValueConfig.appearance.horizontal._key
};

export { KeyValue as default };
